export enum GalleryAction {
  REMOVE = 'REMOVE',
  UNLINK_LINKED_DOCUMENTATION = 'UNLINK_LINKED_DOCUMENTATION',
  DRAW = 'DRAW',
  DOWNLOAD = 'DOWNLOAD',
  REFRESH_PREVIEW = 'REFRESH_PREVIEW',
  EDIT = 'EDIT',
  ROTATE = 'ROTATE',
  SHOW_ISSUES = 'SHOW_ISSUES',
  FILTERS = 'FILTERS',
  EXPORT_TO_DOCUMENTATION = 'EXPORT_TO_DOCUMENTATION',
  GO_TO_SOURCE_ISSUE = 'GO_TO_SOURCE_ISSUE',
  GO_TO_DOCUMENTATION_FILE = 'GO_TO_DOCUMENTATION_FILE',
  SHARE_LINK = 'SHARE_LINK',
}
